import { render, staticRenderFns } from "./cooperation-agreement-detail.vue?vue&type=template&id=4d954ed5&scoped=true&"
import script from "./cooperation-agreement-detail.vue?vue&type=script&lang=js&"
export * from "./cooperation-agreement-detail.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-agreement-detail.vue?vue&type=style&index=0&id=4d954ed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d954ed5",
  null
  
)

export default component.exports